import styled from '@emotion/styled'
import { typo } from '@mathflat/common/style'

export const S = {
  Modal: styled.div`
    position: relative;
    width: 496px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .modal-body {
      ${typo.body02};
      text-align: center;
      margin-bottom: 24px;
      z-index: 15;
      p {
        margin-bottom: 12px;
      }
      strong {
        font-weight: bold;
      }
    }
  `,
  PreventClickLayer: styled.div`
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  `,
}
